<template>
  <div class="side-menu next">
    <div class="row info-wrapper mob-hide">
      <div class="col-9">
        <p>EOI Booking</p>
        <h2 class="page-heading">Signature Towers</h2>
        <p class="align-data">Juinagar, Navi Mumbai</p>
      </div>
      <!-- </div> -->
      <div class="col-3 pr-0">
         <div class="text-right">
            <img src="/img/icons/pp-logo-2.png" height="100px" width="100px" alt="" class="img-fluid">
          </div>
      </div>
    </div>
    <div class="unit-details">
      <div class="variant-detail">
        <span class="unit-title">Selected Variant </span>
        <span class="unit-value">{{selectedFloor.value}}</span>
      </div>
      <div class="variant-detail">
        <span class="unit-title">Area </span>
        <span class="unit-value">{{selectedFloor.area}} sqft</span>
      </div>
      <div class="variant-detail">
        <span class="unit-title">Price Range</span>
        <span class="unit-value">{{selectedFloor.price}}</span>
      </div>
    </div>
    <div class="platinum-plan">
      <div class="platinum-plan-title">Platinum Plan</div>
      <div class="plan-body">
        <ul class="platinum-list">
          <li ><span class="platinum-feat">₹ 1,00,000 Token Amount <span class="platinum-feat-op">(Refundable)</span></span></li>
           <li ><span class="platinum-feat">confirmed inventory allocation</span></li>
        </ul>
        <span class="terms-conditions">By clicking, you agree to our <a href="#">Terms and conditions</a></span>
        <button @click="selectPlatinum(); book()" class="btn btn-block platinum-btn">Book with Platinum</button>
      </div>
    </div>
    <div class="platinum-plan gold-plan">
      <div class="platinum-plan-title">Gold Plan</div>
      <div class="plan-body">
        <div class="platinum-list">
          <div  class="custom-control custom-radio ">
            <label class="radio-label"> <input type="radio" id="gold-plan" name="planId" class="custom-control-input hidden"
            @click="selectGold()" :checked="planId !== null && planId === 'Gold'"><img src="@/assets/images/plan-select.svg" v-if="planId !== 'Gold'" height="19" width="19" alt="Plan Select" />
            <img src="/img/icons/progress-bar-complete-step-new.svg" v-if="planId === 'Gold'" height="19" width="19" alt="Plan Select" />
            <span>₹ 50,000</span><span class="radio-sub-text">(Refundable Token Amount)</span></label>
          </div>
          <div  class="custom-control custom-radio ">
            <label class="radio-label"> <input type="radio" id="platinum-plan" name="planId" class="custom-control-input hidden"
            @click="selectPlatinum()" :checked="planId !== null && planId === 'Platinum'"><img src="@/assets/images/plan-select.svg" v-if="planId !== 'Platinum'" height="19" width="19" alt="Plan Select" />
            <img src="/img/icons/progress-bar-complete-step-new.svg" v-if="planId === 'Platinum'" height="19" width="19" alt="Plan Select" />
            <span>₹ 1,00,000</span><span class="radio-sub-text">(Refundable Token Amount)</span></label>
          </div>
        </div>
        <div class="submit-button-section">
        <span class="terms-conditions">By clicking, you agree to our <a href="#" v-b-modal.termsModal>Terms and conditions</a></span>
        <button @click="book" :disabled="!planId" class="btn btn-block platinum-btn">Book</button>
      </div>
      </div>
    </div>
  <div class="row back-section">
    <button @click="$router.push({name:'Floorplan',query:{...$route.query}})" type="button" class="prevButton">
      <img src="@/assets/images/back-arrow.svg" alt="">
      Back</button>
    </div>
    <div class="col-12 powered-by">Powered by <span class="powered-by-ppistol"> PropertyPistol&nbsp;Technologies</span></div>
<TermsAndConditions/>
</div>
</template>
<script>
import { masterJson } from '@/assets/scripts/utility.js'
export default {
  components:{
    TermsAndConditions:()=>import('@/components/TermsAndConditions.vue')
  },
  methods: {
    selectFloor(floor) {
      this.$store.dispatch('setFloor', floor);
    },
    selectGold(){
      this.$store.dispatch('setAmount',50000);
      this.$store.dispatch('setPlanId','Gold');
    },
    selectPlatinum(){
      this.$store.dispatch('setAmount',100000);
      this.$store.dispatch('setPlanId','Platinum');
    },
    book(){
  if (!this.planId) {
    alert("Please select a plan first");
    return;
  }

  this.$store.dispatch('setLoading', true);

  this.$router.push({
    name: 'PaymentDetails',
    query: { ...this.$route.query }
  });
}
  },
  computed: {
    variants() {
      return masterJson.Variants;
    },
    selectedFloor() {
      return this.$store.getters.selectedFloor;
    },
    selectedTypology() {
      return this.$store.getters.selectedTypology;
    },
    planId(){
      return this.$store.getters.planId
    }
  }
}
</script>
<style scoped>
h3 {
  font-weight: 600;
  font-size: 18px;
  color: #082D57;
  border-bottom: 2px solid #F5F5F5;
  padding: 16px;
}
.side-menu{
   border: none;
}

 .info-wrapper{
    margin-bottom: 40px;
    background: #fff;
    padding-right: 15px;
    border-radius: 10px;
    display: flex;
 }

  .info-wrapper h2{
    font-size: 12px;
    font-weight: bold;
    color: #000;
    margin-bottom: 10px;
  }
     .info-wrapper .page-heading {
    font-size: 12px;
    font-weight: bold;
    color: #000;
    font-weight: 700;
    font-size: 24px;
    margin-bottom: 4px;
  }

  .info-wrapper p {
    font-size: 13px;
    color: #000000;
    line-height: 16px;
    text-transform: uppercase;
    opacity: 0.5;
    padding-left: 0px;
    padding-bottom: 0px;
    margin-bottom: 14px;
  }
.info-wrapper .align-data {
    font-size: 13px;
    color: #000000;
    line-height: 16px;
    text-transform: none;
    opacity: 0.5;
    padding-left: 0px;
    padding-top: 0;
    margin-bottom: 0;
 }

.back-section{
  padding-left: 15px;
}
.prevButton {
  color: #494899;
  border: none;
  background: transparent;
  font-weight: 600;
  font-size: 16px;
  margin-top: 30px;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  transition: 0.3s;
}

.prevButton:hover{
  gap: 10px;
}

.unit-details{
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
}

.unit-details .unit-title{
  display: block;
  color: #00000080;
  margin-bottom: 6px;
}
.platinum-list{
  margin-top: 8px;
  margin-bottom: 28px;
  /* display: flex; */
  align-items: center;
  justify-content: space-between;
}

.platinum-list .radio-label{
  display: flex;
  text-align: center;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  flex-direction: column;
}

.platinum-list .radio-label{
  font-size: 16px;
  color: #000000;
  font-weight: 600;
}

.platinum-list .radio-label .radio-sub-text{
  font-size: 12px;
  font-weight: 400;
  color: #00000080;
}
.platinum-list .radio-label img{
  margin-bottom: 3px;
}
.platinum-plan{
  background: #FFFFFF;
  border: 1px solid rgba(73, 72, 153, 0.2);
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.03);
  border-radius: 10px;
  margin-top: 30px;
}

.platinum-plan-title{
  padding:16px;
  background: #4948991A;
  border-radius: 10px 10px 0px 0px;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
}

.gold-plan .platinum-plan-title{
  background: #f5831f5f;
}

.plan-body{
  padding: 16px;
}

.plan-body ul{
  list-style-position: inside;
  padding-left: 0;
}

.plan-body ul li{
  list-style-type:none;
  position: relative;
}

.plan-body ul li::before {
  content: '';
  position: absolute;
  height: 6px;
  width: 6px;
  background: #494899;
  transform: rotate(45deg);
  top: 8px;
  left: 0;
}

.gold-plan .plan-body ul li::before{
  background: #AB3E91;
}

.plan-body li .platinum-feat{
  position: relative;
  left: 16px;
}
.platinum-feat{
  color: #000000;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
}

.platinum-feat .platinum-feat-op{
  font-weight: 400;
  color: #00000080;
}

.platinum-btn{
  background: #494899;
  border-radius: 4px;
  padding: 16px;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  color: #ffffff;
}

.platinum-btn:focus, .platinum-btn.focus{
  box-shadow: none;
}
.platinum-btn:hover, .platinum-btn:active{
  color: #ffffff;
}

.gold-plan .platinum-btn{
  background: #F5821F;
}
.unit-details .unit-value{
  display: block;
  color: #000000;
}

.terms-conditions{
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  display: inline-block;
  text-align: center;
  width: 100%;
  margin-bottom: 16px;
}

.terms-conditions a{
  color: #AB3E91;
  font-weight: 600;
}
.powered-by{
  font-weight: 400;
  font-size: 11px;
  line-height: 13px;
  color: #00000080;
  text-align: center;
  margin-top: 20px;
}
.powered-by .powered-by-ppistol{
  color: #000000;
}

@media (max-width:991px) {
  .powered-by{
    display: none;
  }
  .mob-hide{
    display: none;
  }
  .prevButton{
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 30px;
  }

  .info-wrapper{
    margin-left: 20px;
    margin-right: 16px;
    padding-right: 0;
  }
  .info-wrapper .col-9{
    padding-left: 0;
  }
  .unit-details{
    padding-left: 20px;
    padding-right: 16px;
  }
  .platinum-plan{
    border-radius: 0;
  }
  .platinum-plan-title{
    border-radius: 0;
  }
  .back-section{
    background: #f6f6f6;
    margin-left: 0;
    margin-right: 0;
  }

  .submit-button-section{
    position: fixed;
    bottom: 0;
    padding: 16px;
    background: #ffffff;
    left: 0;
    z-index:1003;
    width: 100%;
    border: 1px solid rgba(73, 72, 153, 0.2);
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.03);
  }
}
</style>